module.exports = __webpack_public_path__ + "img/type.fceccda3.svg";